import * as fromDatatype from '../datatype-library';

export interface bl_cms_notification_scheduler_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  notification_hdr_guid: fromDatatype.GuidDataFieldInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  last_execution_date: fromDatatype.TimestampTzDatatypeInterface;
  execution_start_date: fromDatatype.TimestampTzDatatypeInterface;
  next_execution_date: fromDatatype.TimestampTzDatatypeInterface;
  is_recurring: boolean;
  code: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  acl_config: any;
  acl_policy: any;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_cms_notification_scheduler_RowClass implements bl_cms_notification_scheduler_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  notification_hdr_guid: fromDatatype.GuidDataFieldInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  last_execution_date: fromDatatype.TimestampTzDatatypeInterface;
  execution_start_date: fromDatatype.TimestampTzDatatypeInterface;
  next_execution_date: fromDatatype.TimestampTzDatatypeInterface;
  is_recurring: boolean;
  code: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  acl_config: any;
  acl_policy: any;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}